import { createContext, useContext } from 'react';

/**
 * Context to provide a custom container for all Radix UI portals.
 * In the SDK, this is set to the Shadow DOM root element so that
 * portaled content (popovers, dropdowns, tooltips) stays inside
 * the Shadow DOM and retains style isolation from the host page.
 *
 * When not provided (null), Radix defaults to document.body (normal behavior).
 */
const PortalContainerContext = createContext<HTMLElement | null>(null);

export const PortalContainerProvider = PortalContainerContext.Provider;

/**
 * Returns the portal container element, or undefined if not set.
 * Radix Portal's `container` prop accepts HTMLElement | undefined.
 */
export function usePortalContainer(): HTMLElement | undefined {
  const container = useContext(PortalContainerContext);
  return container || undefined;
}
